import { render, staticRenderFns } from "./ListTaxiBranch.vue?vue&type=template&id=c8b4d1f2&"
import script from "./ListTaxiBranch.vue?vue&type=script&lang=js&"
export * from "./ListTaxiBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports